import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { DomUtil } from "../../util/DomUtil";
import { PageContext } from "../../service/PageContext";

export class EmailSignUpSuccessModal extends Component {
  public static readonly SignedUpForEmails = "SignedUpForEmails";

  constructor(element: HTMLElement, pageContext: PageContext) {
    super(element, pageContext);
    window.addEventListener(EmailSignUpSuccessModal.SignedUpForEmails, ev =>
      this.showSignUpModal(ev as CustomEvent<string>));
  }
  private showSignUpModal(ev: CustomEvent<string>): void {
    const modalBody = DomUtil.query(this._element, "div.modal-body");
    if (modalBody) {
      modalBody.innerHTML = ev.detail;
      $(this._element).modal("show");
    }

  }
}

ComponentFactory.registerComponent("EmailSignUpSuccessModal",
  EmailSignUpSuccessModal);
